module.exports = __webpack_public_path__ + "img/bodega.bda0049b.svg";